import { useCallback, type MouseEvent as ReactMouseEvent } from 'react';

import { createClassName, createStyleHelper } from '../../utils/class-names';
import type { FCWithChildren } from '../../utils/component.interface';
import { ContextNavLink } from '../context-nav-link/context-nav-link';

import styles from './tab.module.scss';

const style = createStyleHelper(styles, 'tab');

export interface ITabProps {
    className?: string;
    onClick?: () => void;
    isActive?: boolean;
    disabled?: boolean;
    href?: string;
    thick?: boolean;
    align?: 'left' | 'center';
}

export const Tab: FCWithChildren<ITabProps> = ({
    className,
    onClick,
    children,
    isActive: isActiveProp = false,
    thick = false,
    href,
    disabled = false,
    align = 'center',
}) => {
    const onClickHandler = useCallback(
        (ev: ReactMouseEvent<HTMLAnchorElement, MouseEvent>) => {
            if (onClick || disabled) {
                ev.preventDefault();
            }
            onClick?.();
        },
        [onClick, disabled],
    );

    return (
        <ContextNavLink
            className={useCallback(
                ({ isActive }: { isActive: boolean }) =>
                    createClassName([
                        className,
                        style(undefined, {
                            active: isActive || isActiveProp,
                            thick,
                            [align]: true,
                        }),
                    ]),
                [align, className, isActiveProp, thick],
            )}
            onClick={onClickHandler}
            to={href || ''}
        >
            {children}
        </ContextNavLink>
    );
};
